import React from 'react';

type MessageContextType = {
    messageToDelete: string | null;
    setMessageToDelete: (messageToDelete: string | null) => void;
    chatType: string | null;
    setChatType: (chatType: string | null) => void;
    chatTypeId: string | null;
    setChatTypeId: (chatTypeId: string | null) => void;
};

const MessageContext = React.createContext<MessageContextType | null>(null);

export default MessageContext;
